
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125485152",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1947",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M511.76459952 340.77179268h-2.51707557c-1.13228947 12.64850194-3.61780295 24.79464083-7.51966458 36.49891067l-49.33678506 150.77861228h115.0976854l-49.05404147-149.64632281c-3.1456869-9.46993788-5.38001886-22.02506867-6.67011872-37.63120014z",
        "p-id": "1948"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M7.03966189 6.99363386v1009.98643056h1009.98643055v-1009.98643056h-1009.98643055z m192.1985766 875.73451031c-28.91612193 0-52.35753875-23.44141683-52.35753875-52.35753875s23.44141683-52.35753875 52.35753875-52.35753875 52.35753875 23.44141683 52.35753876 52.35753875-23.44141683 52.35753875-52.35753876 52.35753875z m0-631.18234021c-28.91612193 0-52.35753875-23.44141683-52.35753875-52.35753875s23.44141683-52.35753875 52.35753875-52.35753876 52.35753875 23.44141683 52.35753876 52.35753876-23.44141683 52.35753875-52.35753876 52.35753875z m422.30715172 446.47712646l-32.31430543-98.92475165H432.34784099l-31.77906523 98.92475165h-99.74273546l157.9839712-431.66530724h108.14482309L721.8878051 698.02293042h-100.34241489z m199.93917574 184.70521375c-28.91612193 0-52.35753875-23.44141683-52.35753874-52.35753875s23.44141683-52.35753875 52.35753874-52.35753875 52.35753875 23.44141683 52.35753875 52.35753875-23.44141683 52.35753875-52.35753875 52.35753875z m0-631.18234021c-28.91612193 0-52.35753875-23.44141683-52.35753874-52.35753875s23.44141683-52.35753875 52.35753874-52.35753876 52.35753875 23.44141683 52.35753875 52.35753876-23.44141683 52.35753875-52.35753875 52.35753875z",
        "p-id": "1949"
      }
    }
  ]
})
    }
  